import React, { useState, useEffect } from "react";
import { Grid, Button, Typography, IconButton } from "@material-ui/core";
import InputField from "src/components/ui-components/InputField";
import SelectField from "src/components/ui-components/SelectField";
import { getIcons } from "./ConnectionService";
import { AddCircle, Delete } from "@material-ui/icons";
import SubMenuFilterCreateEdit from "./SubMenuFilterCreateEdit";
import { FieldArray } from "formik";
import AlertMessage from "src/components/ui-components/AlertMessage";
import SwitchField from "src/components/ui-components/SwitchField";

const defaultPageFilter = {
  pageFilterKey: null,
  pageKey: "",
  pageFilterName: "",
  pageFilterType: "",
  pageFilterWebMethodKey: "",
  hasConfigurableWidgets: false,
  sortOrder: 0,
  isEnabled: false,
  pageFilterValues: [],
};

const SubMenuCreateEdit = ({ pages, index }) => {
  const [iconsData, setIconsData] = useState([]);
  useEffect(() => {
    const fetchIcons = async () => {
      try {
        const res = await getIcons();
        setIconsData(res);
      } catch (err) {
        AlertMessage({ type: "error", msg: err.title });
      }
    };

    fetchIcons();
  }, []);

  return (
    <>
      <Grid spacing={5} container>
        <Grid item xs={6}>
          <InputField
            label={`Sub Menu`}
            name={`pages.${index}.pageName`}
            fullWidth
            sx={{ marginBottom: 5 }}
          />
        </Grid>
        <Grid item xs={6}>
          <InputField
            label={`Sub Menu Route`}
            name={`pages.${index}.pageAddress`}
            fullWidth
            sx={{ marginBottom: 5 }}
            disabled
            onChange={() => {}}
          />
        </Grid>
      </Grid>
      <Grid container spacing={5}>
        <Grid item xs={6}>
          <SelectField
            label="Icon Name"
            name={`pages.${index}.IconMasterKey`}
            data={iconsData}
            dataTextField="IconName"
            dataValueField="IconMasterKey"
          />
        </Grid>
        <Grid item xs={6}>
          <InputField
            label={`Sort Order`}
            name={`pages.${index}.sortOrder`}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <SwitchField name={`pages.${index}.isEnabled`} label="Is Enabled" />
        </Grid>
        <Grid item xs={12} md={12} lg={12}>
          <FieldArray name={`pages.${index}.pageFilter`}>
            {({ push, remove }) => (
              <>
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  xl={12}
                  sx={{
                    textAlign: "right",
                    paddingRight: 2,
                    padding: 2,
                  }}
                >
                  <Button
                    sx={{
                      background:
                        "linear-gradient(to bottom, #09735e, #09735e)",
                      minWidth: 100,
                      marginRight: 1,
                    }}
                    variant="contained"
                    type="button"
                    startIcon={<AddCircle />}
                    disabled={pages[index]?.pageFilter?.length > 0}
                    onClick={() => {
                      push({ ...defaultPageFilter, sortOrder: 1 });
                    }}
                  >
                    Add Filter
                  </Button>
                  <Button
                    sx={{
                      background:
                        "linear-gradient(to bottom, #09735e, #09735e)",
                      minWidth: 100,
                      marginRight: 1,
                    }}
                    variant="contained"
                    type="button"
                    startIcon={<AddCircle />}
                  >
                    Add Widget
                  </Button>
                </Grid>
                {pages[index]?.pageFilter?.map((pageFilter, indexFilter) => (
                  <React.Fragment key={indexFilter}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{ marginBottom: 1 }}
                    >
                      Sub Menu Filter
                      <IconButton
                        type="button"
                        onClick={() => {
                          remove(indexFilter);
                        }}
                      >
                        <Delete style={{ fontSize: 20 }} />
                      </IconButton>
                    </Typography>
                    <SubMenuFilterCreateEdit
                      pages={pages}
                      index={index}
                      indexFilter={indexFilter}
                    />
                  </React.Fragment>
                ))}
              </>
            )}
          </FieldArray>
        </Grid>
      </Grid>
    </>
  );
};

export default SubMenuCreateEdit;
